


























































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class WhoWeAre extends Vue {
  get googlePlay(): string {
    return require("../assets/images/google-play1.png");
  }
  get appStore(): string {
    return require("../assets/images/appstore1.png");
  }
  get aboutAuthenticLabs(): string {
    return require("../assets/images/aboutAuthenticLabs.png");
  }

  // TODO for now create a placeholder object for missions (title and text)
  // missions: any[] = [];
  missions = [
    {
      title: "We empower consumers",
      text: "Real helps consumers make purchase decisions that support their values and the brands that deliver on them. Real lets you explore where a company stands in terms of commitments to values, the environment, ethical supply chain, citizenship, diversity and safety.",
      imageUrl: require("@/assets/images/weempowerconsumers.png"),
    },
    {
      title: "We enable brands",
      text: "We provide brands with tools to deliver the content consumers really want at the point-of-purchase and throughout product ownership. We help brands print less and reduce packaging cost, and we provide a safe platform to build consumer engagement.",
      imageUrl: require("@/assets/images/weenablebrands.png"),
    },
    {
      title: "We protect your privacy",
      text: "We don’t create personal profiles of you based on your search history. We don’t sell your information to advertisers. We only collect the data we absolutely need to improve Real and provide feedback from brands on what consumers really care about.",
      imageUrl: require("@/assets/images/weprotectprivacy.png"),
    },
  ];
  // TODO end hardcode
}
